export default __webpack_public_path__ + "static/media/GreenMarker.ac27e398.svg";